import { Search, VisibilityRounded,CloseRounded as CloseIcon, Edit } from "@mui/icons-material";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { CheckBoxWithLabel, CustomAutoComplete, InputWithLabel, SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType, FormActions, TiposVehiclos, TipoVehiculoEntity } from "../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../components/form/ModalForm";








/* 
const ModalDetalleProducto = ({
  isVisible,
  Criterios=[],
  productName,
  unidad_medida,
  OnCloseModalDetalle
})=>{

  const [criteriosOrdered,setCriteriosOrdered] = useState([]);
  const [isVisbleModalForm,setIsVisibleModalForm] = useState(false);
  const [itemSeleccionado,setItemSeleccionado] = useState(TipoVehiculoEntity);


  useEffect(()=>{

    OrderDataToPrint();
  },[Criterios]);

  let OrderDataToPrint = ()=>{
   let NuevosCriterios = [];
    console.log({Criterios});
   const IsKeyInList = (key)=>{

   return  NuevosCriterios.findIndex( Ncriterio => Ncriterio.label === key );
  }
  Criterios.forEach(crt=>{
      let IndexItem = IsKeyInList(crt.descripcion_plan) ;
    if ( IndexItem !== -1){

      NuevosCriterios[IndexItem].SubItems.push({
        label:crt.descripcion_plan,
        value:`${crt.cod_mayor}+${crt.cod_plan}`
      });

    }else{

      NuevosCriterios.push({
        key:`${crt.descripcion_plan}-${crt.cod_mayor}-${crt.cod_plan}`,
        label:String(crt.descripcion_plan).toLowerCase(),
        SubItems:[{
          label:crt.descripcion_mayor,
          value:`${crt.cod_mayor}+${crt.cod_plan}`
        }]
      });

    }

  });
  setCriteriosOrdered(NuevosCriterios);
  console.log({NuevosCriterios});
  }

  return (
    <Dialog
     open={isVisible}
     maxWidth="md"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} >
      <Grid container >
        <Grid item sm={10} md={10}  >
          <Typography variant="h6"  alignContent="center" textAlign="left" >
              {productName} {unidad_medida? '- '+unidad_medida:''}
        </Typography>
      </Grid>
        <Grid item sm={2} md={2} alignContent="center" textAlign="center" >
          <IconButton
            aria-label="close"
            onClick={OnCloseModalDetalle}
            sx={{
              fontWeight:"bold",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      
    </DialogTitle>
    <DialogContent>
          <Grid container >
            <Grid  item sx={12} md={12} >
             <Typography variant="subtitle1" >
                Criterios de clasificacion
             </Typography>
            </Grid>
            <Grid container item sx={12} md={12} >
              {
                criteriosOrdered.map( criterioOrdered=> <Grid key={criterioOrdered.key} item sm={4} md={4} >
                      <CustomAutoComplete
                       multiple
                       disabled
                       id="tags-standard"
                       options={criterioOrdered.SubItems}
                       getOptionLabel={(option) => option.label}
                       isOptionEqualToValue={(option,value)=>{
                       
                        
                        return option.value === value.value;
                       }}
                       defaultValue={criterioOrdered.SubItems}
                       renderInput={(params) => (
                         <TextField
                         
                           {...params}
                           variant="standard"
                           label={criterioOrdered.label}
                          
                         />
                       )}
                      />
                  </Grid> )
              }
             
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={OnCloseModalDetalle} >OK, Cerrar</Button>
        </DialogActions>
    </Dialog>
  )

} */









const schema = yup.object({
  descripcion: yup.string().required(),
  largo: yup.number().required(),
  ancho: yup.number().required(),
  alto: yup.number().required(),
  tipo: yup.string().required(),
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestroTiposVehiculos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...TipoVehiculoEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);



    useEffect(()=>{

      loadItems();


    },[]);

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);
    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/obtener-tipos-vehiculos",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      setProductoSeleccionado(product || {});
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
    }
    const onCloseModalItem = ()=>{
      setIsVisibleModalDetalle(false);
    }
    const onOpenModalItem = (edit=false)=>{
      console.log({edit});
      if (!edit){
        setProductoSeleccionado({...TipoVehiculoEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
      const urlService = typeAction === FormActions.AGREGAR?'maestros/crear-tipo-vehiculo':'maestros/mod-tipo-vehiculo/'+dataForm.cod;
        console.log({
          typeAction,
          dataForm
        });
        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,dataForm)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"Descripcion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"largo",
        keyValue:"largo",
        label:"Largo (metros)",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"ancho",
        keyValue:"ancho",
        label:"Ancho (metros)",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"alto",
        keyValue:"alto",
        label:"Alto (metros)",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"peso",
        keyValue:"peso",
        label:"Peso (KG)",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"es_activo",
        keyValue:"es_activo",
        label:"Activo",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value?'SI':'NO',
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"tipo",
        keyValue:"tipo",
        label:"Tipo",
        
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       
       {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];

    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar tipo de vehiculo":'Modificar tipo de vehiculo',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"descripcion",
          keyValue:"descripcion",
          label:"Descripcion",
          component:InputWithLabel,
          inputProps:{
            type:"text"
          }
        },
        {
          key:"largo",
          keyValue:"largo",
          label:"Largo (metros)",
          component:InputWithLabel,
          inputProps:{
            type:"number"
          }
        },
        {
          key:"ancho",
          keyValue:"ancho",
          label:"Ancho (metros)",
          component:InputWithLabel,
          inputProps:{
            type:"number"
          }
        },
        {
          key:"alto",
          keyValue:"alto",
          label:"Alto (metros)",
          component:InputWithLabel,
          inputProps:{
            type:"number"
          }
        }, 
        {
          key:"peso",
          keyValue:"peso",
          label:"Peso (KG)",
          component:InputWithLabel,
          inputProps:{
            type:"number"
          }
        }, 
        {
          key:"tipo",
          keyValue:"tipo",
          label:"Tipo",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            items: Object.keys(TiposVehiclos).map(keys=>({label:keys.replace(/-/g," "),value:TiposVehiclos[keys] }))
          }
        },
        {
          key:"es_activo",
          keyValue:"es_activo",
          label:"¿Esta activo?",
          component:CheckBoxWithLabel,
          inputProps:{
            type:"checkbox",
           // items: Object.keys(TiposVehiclos).map(keys=>({label:keys.replace(/-/g," "),value:TiposVehiclos[keys] }))
          }
        },
      ],
      arrayInputs:[]
    } ;

    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar producto"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo tipo de vehiculo</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}